import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
export const IdleTimeOutModal = ({ showModal, handleClose, handleLogout }) => {
  return (
    <div>
      <Dialog
        open={showModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-Idle"
        aria-describedby="Idle Timeout Dialog"
      >
        <DialogTitle id="alert-dialog-title">
          {'You have been inactive for a while!'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            For security purposes, your session will time out in approximately 1
            minute. Choose <b>Stay signed in</b> to continue or <b>Sign out</b>{' '}
            if you&apos;re done.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleLogout}
            color="primary"
            variant="contained"
            style={{ paddingRight: 35, paddingLeft: 35 }}
          >
            Sign out
          </Button>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            autoFocus
            style={{ paddingRight: 35, paddingLeft: 35 }}
          >
            Stay signed in
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

IdleTimeOutModal.propTypes = {
  showModal: PropTypes.bool,
  handleClose: PropTypes.func,
  handleLogout: PropTypes.func,
};
